import React from 'react'

export default function MobileAppTipsCard({ appValidTill, notificationBalance, isExpired = false }) {
  const formatDate = (dateStr) => {
    if (!dateStr) return 'Active'
    try {
      return new Date(dateStr).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })
    } catch {
      return dateStr
    }
  }

  return (
    <div className="flex flex-col gap-4 rounded-3xl border border-outline-variant/25 bg-surface-container-lowest p-6 shadow-xs">
      {/* Header */}
      <div className="flex items-center gap-2 text-primary font-bold text-sm border-b border-outline-variant/15 pb-4">
        <span className="material-symbols-outlined text-base">info</span>
        <span>App Subscription &amp; Status</span>
      </div>

      {/* Status Badges Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {/* App Validity */}
        <div className="flex flex-col gap-1 rounded-2xl border border-outline-variant/20 bg-surface-container-low/40 p-3.5">
          <span className="text-[10px] font-black uppercase tracking-wider text-on-surface-variant">
            Mobile App Validity
          </span>
          <div className="flex items-center gap-1.5">
            <span
              className={`h-2.5 w-2.5 rounded-full ${
                isExpired ? 'bg-rose-500 animate-pulse' : 'bg-emerald-500'
              }`}
            />
            <span className="text-xs font-black text-on-surface">
              {isExpired ? 'Expired' : `Valid till ${formatDate(appValidTill)}`}
            </span>
          </div>
        </div>

        {/* Notifications Balance */}
        <div className="flex flex-col gap-1 rounded-2xl border border-outline-variant/20 bg-surface-container-low/40 p-3.5">
          <span className="text-[10px] font-black uppercase tracking-wider text-on-surface-variant">
            Push Notification Balance
          </span>
          <div className="flex items-center gap-1.5 text-primary">
            <span className="material-symbols-outlined text-sm">notifications_active</span>
            <span className="text-xs font-black text-on-surface">
              {notificationBalance ? `${notificationBalance.toLocaleString()} Credits` : 'Disabled'}
            </span>
          </div>
        </div>
      </div>

      {/* Operational Notes */}
      <div className="rounded-2xl border border-outline-variant/15 bg-surface-container-low/30 p-4">
        <h4 className="text-xs font-bold text-on-surface flex items-center gap-1.5 mb-2">
          <span className="material-symbols-outlined text-sm text-primary">help</span>
          <span>Important Operating Notes</span>
        </h4>
        <ul className="space-y-2 text-[11px] text-on-surface-variant list-disc pl-4 leading-relaxed">
          <li>
            Use these switches to instantly enable or disable student &amp; parent app access per module.
          </li>
          <li>
            Students and parents will see a standard <i>'No data found'</i> notice if a feature is disabled or subscription pack expires.
          </li>
          <li>
            Institution logo uploaded here will reflect in the mobile app header and push notifications.
          </li>
          <li>
            When dispatching messages, the system automatically routes alerts via mobile push notification (if installed), with automatic fallback to SMS.
          </li>
        </ul>
      </div>
    </div>
  )
}
